import React, { HTMLAttributes } from 'react';
import c from 'classnames';

import { CoreLink } from '../../../../../components';
import { SCREEN_NORMAL } from '../../../../../config/constants';
import useClasses from '../../../../../hooks/useClasses';
import useWindowDimensions from '../../../../../hooks/useWindowDimensions';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLUListElement>> {
  title: string,
  titleMobile: string,
  href: string,
}

const MenuMainItemStatistic: React.FC<Props> = ({
  className, title, href, titleMobile,
}) => {
  const { width } = useWindowDimensions();
  const { buildClass, joinClasses } = useClasses('MenuMainItem', 'statistic');

  const iconClasses = c(
    'icon',
    className,
  );

  return (
    <li key={href}>
      <CoreLink to={href} className={joinClasses(buildClass(), 'menu-item')}>
        <div className={joinClasses(buildClass('icon'), iconClasses)} />
        {width >= SCREEN_NORMAL ? title : titleMobile}
      </CoreLink>
    </li>
  );
};

export default MenuMainItemStatistic;
